export const markerFormatter = (marker) => ({
    ...marker,
    totalPieces: marker.sizesCount.reduce(
        (total, current) => total + current.count,
        0
    ),
    toleranceP: ((marker.tolerance / marker.length) * 100).toFixed(0),
    sizes: marker.sizesCount.map((item) => item.size.name),
});
